<template>
  <span :class="classnames">
    <slot />
  </span>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'button-style'

  const modifiers = {
    isActive: 'is-active',
    isDisabled: 'is-disabled'
  }

  export default {
    name: 'ButtonStyle',
    mixins: [ bem ],
    props: {
      appearance: {
        default: 'default',
        type: String,
        validator: function (value) {
          return [
            'black',
            'cta',
            'default',
            'large',
            'none',
            'wide',
            'fat-light',
            'fat-dark'
          ].indexOf(value) !== -1
        }
      },
      isActive: {
        default: false,
        type: Boolean
      },
      isDisabled: {
        default: false,
        type: Boolean
      }
    },
    data () {
      return {}
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      classnameModifiers: function () {
        const appearance = this.appearance && this.appearance
        const isActive = this.isActive && modifiers.isActive
        const isDisabled = this.isDisabled && modifiers.isDisabled

        return [
          appearance,
          isActive,
          isDisabled
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/ButtonStyle.vue